import React from "react";
// import { useParams } from "react-router-dom";

import Card from "@mui/material/Card";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";

// Material Kit 2 PRO React examples
import DefaultFooter from "components/Footers/DefaultFooter";
import NavbarHeader from "layouts/navbar-header/blockchain-details/index.js";

// Blockchain Detail layouts import
import BasicInfo from "pages/BlockchainDetails/Sections/BasicInfo";

// Routes
import footerRoutes from "footer.routes";

function BlockchainDetails() {
    // const { network, name } = useParams(); // Fetch the blockchain name from the URL

    // const headerRef = useRef(null);

    return (
        <>
            <NavbarHeader />

            <Card
                sx={{
                    p: 2,
                    mx: { xs: 2, lg: 3 },
                    mt: -8,
                    mb: 4,
                    boxShadow: ({ boxShadows: { xxl } }) => xxl,
                }}
            >
                <BasicInfo />
            </Card>
            <MKBox pt={6} px={1} mt={6}>
                <DefaultFooter footerContent={footerRoutes} />
            </MKBox>
        </>
    );
}

export default BlockchainDetails;
